export const globalInitState = () => {
    return {
        history: [],
        theme: 'light-theme',
        alert: null,
    }
}

export const errorsInitState = () => {
    return {
        login: null,
        signup: null,
        createEvent: null,
    }
}

export const eventsInitState = () => {
    return {
        currentEvent: null,
        events: null,
        types: null,
        myEvents: null
    }
}

export const authInitState = () => {
    return {
        user: null,
        userDetail: null
    }
}

export const profilesInitState = () => {
    return {
        profiles: []
    }
}

export const invitationsInitState = () => {
    return {
        invitations: null,
        currentInvitation: null,
    }
}

export const commentsInitState = () => {
    return {
        comments: null,
        currentComment: null,
    }
}
export const notificationsInitState = () => {
    return {
        notifications: null,
    }
}

export const itemsInitState = () => {
    return {
        miscellaneous: null,
        games: null
    }
}
